import "core-js/modules/es.array.concat";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import moment from 'moment';
import Block from 'wfui-digital-core/es/Block';
import useStrings from 'wfui-digital-core/es/useStrings';
import styles from './CopyRight.less';
export default (function () {
  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  return /*#__PURE__*/React.createElement(Block, {
    className: styles.copyright
  }, "\xA9 1999 - ".concat(moment().year(), " Wells Fargo. ").concat(getString('global.rights.reserved'), ". NMLSR ID 399801"));
});